// extracted by mini-css-extract-plugin
export default {"courseSelector":"course-selector_courseSelector__a-IOn"};